import React, { useState, useEffect } from 'react';


import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {Link} from 'react-router';
import {connect} from 'react-redux';
import * as actions from '../../store/property/actions';
import PropertyCard from '../../components/property/propertyCard';



const HomePageFeaturedProperties = ({getFeaturedProperties, featuredProperties}) => {   

    useEffect(() => {
		loadData();
	},[]);

    

    const loadData = async() => {
        await getFeaturedProperties({no_of_properties: 6}).then(res => {
            // console.log()
        });
    }

    if(featuredProperties && featuredProperties.length > 0){
        return (
            
                <section className='pt-5 pb-5'>
                            <Container>
                                <h3 className="text-center mb-4">Top Properties in Jaipur</h3>
                                <Row>
                                    {
                                        featuredProperties.map((featuredProperty, featuredPropertyIndex) => {
                                            return <Col md={6} xl={4} key={`featuredProperty${featuredPropertyIndex}`}>
                                                <PropertyCard item={featuredProperty} />
                                            </Col>
                                        })
                                    }
                                    
                                    
                                </Row>
                                <div className='text-center mt-3'><Link to={`/top-properties-in-jaipur/all`} className="btn btn-primary">See All Properties</Link></div>
                            </Container>
                        </section>
        )
    } else {
        return null;
    }
}

function mapStateToProps(state) {
    return {
        featuredProperties: state.property.featuredProperties.properties
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        getFeaturedProperties: (post) => dispatch(actions.getFeaturedProperties(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(HomePageFeaturedProperties);